import type {
  CreateFixedRateLoanProduct,
  CreateFloatingRateLoanProduct,
  CreateOTCForwardProduct,
  CreateOTCOptionProduct,
  CreateRepoProduct,
} from '@src/types/OTC';
import type { DealProductBuilderRow } from '@src/types/OTC/otcProductBuilderTypes';
import { getRestFailureUserMessage } from '@src/utils/rtkQuery';
import type {
  CustomInstrumentCreateResponseRow,
  CustomInstrumentPostBody,
} from '../endpoints/customInstrumentEndpoint';
import type { CreateFloatingRateLoanRequest, CreateVanillaOptionRequest } from './CustomInstrumentTypes';

export type CreateProductParams = {
  rowData: DealProductBuilderRow;
  createCustomInstrument: (body: CustomInstrumentPostBody) => Promise<CustomInstrumentCreateResponseRow[]>;
  onSuccess: (message: string) => void;
  onError: (message: string) => void;
};

export abstract class BaseProductDefinition {
  protected getServerErrorMessage(error: unknown): string | undefined {
    return getRestFailureUserMessage(error);
  }

  abstract checkForUniqueness(row: DealProductBuilderRow): 'notReady' | 'uncreated' | 'conflict' | 'alreadyCreated';
  abstract buildPostBody(
    row: object
  ):
    | CreateFixedRateLoanProduct
    | CreateFloatingRateLoanProduct
    | CreateFloatingRateLoanRequest
    | CreateOTCOptionProduct
    | CreateVanillaOptionRequest
    | CreateOTCForwardProduct
    | CreateRepoProduct
    | undefined;
  abstract createProduct(params: CreateProductParams): Promise<{ symbol: string } | undefined>;
  abstract getProductDetailsForComparison(
    row: DealProductBuilderRow
  ):
    | CreateFixedRateLoanProduct
    | CreateFloatingRateLoanProduct
    | CreateFloatingRateLoanRequest
    | CreateOTCOptionProduct
    | CreateVanillaOptionRequest
    | CreateOTCForwardProduct
    | CreateRepoProduct
    | null;
}
